import { render, staticRenderFns } from "./AddCountry.vue?vue&type=template&id=1f57a610&scoped=true&"
import script from "./AddCountry.vue?vue&type=script&lang=js&"
export * from "./AddCountry.vue?vue&type=script&lang=js&"
import style0 from "./AddCountry.vue?vue&type=style&index=0&id=1f57a610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f57a610",
  null
  
)

export default component.exports